import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { SideBarProvider } from './context/SidebarContext';
import { AuthProvider } from './context/AuthContext';
import { HeadingProvider } from './context/HeadingContext';

const App = () => {
  return (
    <AuthProvider>
      <SideBarProvider>
        <HeadingProvider>
          <RouterProvider router={router} />
        </HeadingProvider>
      </SideBarProvider>
    </AuthProvider>
  )
}

export default App
